import { render, staticRenderFns } from "./DeviceStatistics.vue?vue&type=template&id=b770095c&scoped=true"
import script from "./DeviceStatistics.vue?vue&type=script&lang=js"
export * from "./DeviceStatistics.vue?vue&type=script&lang=js"
import style0 from "./DeviceStatistics.vue?vue&type=style&index=0&id=b770095c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b770095c",
  null
  
)

export default component.exports